import Friendships from '@/friendships/Friendships';
import Frames from '@/frames/Frames';

const Component = () => {
  return (
    <Friendships>
      <Frames />
    </Friendships>
  );
};

export default Component;
